import { inject, signal, Signal } from '@angular/core';
import { injectQuery } from '@tanstack/angular-query-experimental';
import { environment } from 'src/environments/environment';

import { EntitySettingTypes, EntityType, GqlService } from '@shared/services/gql.service';
import { MainQuery } from '@shared/store/main/main.query';
import { gqlToPromise } from '@shared/utils/gql-to-promise';

export const injectGetBalanceSheetsQuery = ({
  vendorId = signal(''),
}: {
  vendorId?: Signal<string>;
} = {}) => {
  const gqlService = inject(GqlService);
  const mainQuery = inject(MainQuery);

  return injectQuery(() => ({
    enabled: !!vendorId(),
    queryFn: () => {
      if (environment.usePlayground) {
        return import('./get-balance-sheets-query.mock').then(
          (m) => m.getBalanceSheetsQueryMock.data.listEntitySettings
        );
      }

      return gqlToPromise(() => {
        return gqlService.listEntitySettings$({
          entity_ids: [vendorId()],
          entity_type: EntityType.ORGANIZATION,
          setting_type: EntitySettingTypes.VENDOR_ACCOUNTS,
        });
      });
    },
    queryKey: [
      'trials',
      'detail',
      mainQuery.trialKey(),
      'list-entity-settings',
      {
        entity_ids: [vendorId()],
        entity_type: EntityType.ORGANIZATION,
        setting_type: EntitySettingTypes.VENDOR_ACCOUNTS,
      },
    ],
  }));
};
